import {CompanyLocation} from "@apps/registration/types/CompanyLocations";

import {InputOption} from "@components/forms/interfaces";

export const formatLocationOptions = (
  locations: CompanyLocation[]
): InputOption[] => {
  return locations.map((location) => ({
    label: location.name || location.address,
    value: location.id.toString(),
  }));
};
